module.exports = "pegasus/assets/theme4/small/7.jpg";